var Sampler = (function () {
    function Sampler(shift, mask, value) {
        this.shift = shift;
        this.mask = mask;
        this.value = value;
    }
    return Sampler;
}());
export { Sampler };



// WEBPACK FOOTER //
// ../dist/lib/aglsl/assembler/Sampler.js